// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"e2ae2be7","496":"cc35b24f","731":"3570e327","962":"4294b3f1"}[chunkId] + ".chunk.js";
};